import { AppState } from '@/vuex/store';

export default {
  ADD_CUSTOMER_PROP: (state: AppState, prop: any) => {
    state.customerState.props.push({
      propName: prop.propName,
      fieldName: prop.fieldName,
      propType: prop.propType,
      propTypeName: prop.propTypeName,
      builtIn: prop.builtIn,
      enumValue: prop.enumValue,
    });
  },
  RENAME_CUSTOMER_PROP: (state: AppState, prop: any) => {
    for (const p of state.customerState.props) {
      if (p.fieldName === prop.fieldName) {
        p.propName = prop.propName;
      }
    }
  },
  DELETE_CUSTOMER_PROP: (state: AppState, fieldName: string) => {
    for (let i = 0; i < state.customerState.props.length; i++) {
      const prop = state.customerState.props[i];
      if (prop.fieldName === fieldName) {
        state.customerState.props.splice(i, 1);
      }
    }
  },
};
